import { useEffect, useRef, useState } from 'react';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import { ReportDetails } from '@/components/Analysis/ReportsRevamped/ReportDetails';

interface ReportDetailDrawerProps {
  reportId: string | null;
  open: boolean;
  onClose: () => void;
}

export const ReportDetailDrawer = ({
  reportId,
  open,
  onClose,
}: ReportDetailDrawerProps) => {
  const ENTER_MS = 800;
  const EXIT_MS = 400;

  const [isTransitioning, setIsTransitioning] = useState(false);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {

    setIsTransitioning(true);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    const ms = open ? ENTER_MS : EXIT_MS;
    timeoutRef.current = window.setTimeout(() => {
      setIsTransitioning(false);
      timeoutRef.current = null;
    }, ms) as unknown as number;

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [open]);

  const handleClose = (event: unknown, reason?: string) => {
    if (reason === 'escapeKeyDown' && isTransitioning) return;
    onClose();
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleClose}
      transitionDuration={{ enter: ENTER_MS, exit: EXIT_MS }}
      ModalProps={{ disableEscapeKeyDown: isTransitioning }}
      PaperProps={{
        sx: {
          height: '100vh',
          borderTopLeftRadius: '12px',
          borderTopRightRadius: '12px',
          overflow: 'hidden',
        },
      }}
    >
      <Box sx={{ height: '100vh', overflowY: 'auto', width: '100%' }}>
        {open && reportId && <ReportDetails key={reportId} reportId={reportId} />}
      </Box>
    </Drawer>
  );
};
